import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-12 px-6 bg-cream-200 border-t border-sage-200">
      <div className="max-w-6xl mx-auto">
        <div className="text-center">
          <h3 className="font-serif text-3xl font-bold text-gray-900 mb-4">
            Wisuda.ai
          </h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Membantu kampus menciptakan acara wisuda yang lebih tertib, informatif, dan berkesan 
            melalui teknologi AI berbasis WhatsApp.
          </p>
          
          <div className="flex items-center justify-center gap-2 text-gray-600">
            <span>Dibuat dengan</span>
            <Heart className="w-4 h-4 text-terracotta-500 fill-current" />
            <span>untuk pendidikan Indonesia</span>
          </div>
          
          <div className="mt-8 pt-8 border-t border-sage-200">
            <p className="text-sm text-gray-600">
              © 2026 PT AI Indonesia. Semua hak dilindungi.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
